import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import LoaderButton from '@common/components/loaderButton';
import PlayerCard from '@app/dev/terminal/components/playerCard';

import { formatMoneyAmount } from '@common/helpers/amount';
import { useBalance } from '@app/dev/terminal/hooks/balance';
import { GetCurrencyConfig } from '@common/helpers/selectors';

import { DepositToClientAccount, PartialDepositToClientAccount } from '@app/dev/actions/terminal';
import { waitForTransferToUserCashoutResponse } from '@app/dev/helpers/transferToUser';

import './style.scss';

const TransferToUserConfirm = ({
  player,
  amount,
  isMaxAmount,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [{ closePopup }] = useContext(PopupContext);
  const balance = useBalance();
  const dispatch = useDispatch();
  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.main.currencySymbolRounding)
  ));

  const visualAmount = isMaxAmount ? balance : amount;

  const t = useTranslation();

  const handleSubmit = async () => {
    setLoading(true);

    const action = Config.balanceTransfer.enablePartialTransferToUser && !isMaxAmount
      ? PartialDepositToClientAccount({ clientId: player.Id, amount: Number(amount) })
      : DepositToClientAccount({ clientId: player.Id });

    dispatch(action);

    const response = await waitForTransferToUserCashoutResponse();

    if (response.success) onSuccess?.();

    setLoading(false);
  };

  return (
    <div className="popup-content popup-small transfer-to-user-confirm-popup">
      <h3 className="popup-title">{t('Transfer')}</h3>

      <i onClick={closePopup} className="global-icon icon-Close close-popup" />

      <p className="popup-subtitle">
        {t.jsx('You are about to transfer {1}', <span className="color-hero">{formatMoneyAmount(visualAmount, Config, currencyConfig)}</span>)}
      </p>

      <div className="popup-main-content">
        <PlayerCard data={player} variant="highlighted" />

        <i className="global-icon icon-transactions popup-main-icon" />
      </div>

      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => closePopup()}
        >
          {t('Cancel')}
        </button>

        <LoaderButton
          type="button"
          onClick={handleSubmit}
          className="popup-confirm-button"
          loading={loading}
        >
          {t('Transfer')}
        </LoaderButton>
      </div>
    </div>
  );
};

TransferToUserConfirm.propTypes = {
  player: PropTypes.object.isRequired,
  amount: PropTypes.number,
  isMaxAmount: PropTypes.bool,
  onSuccess: PropTypes.func,
};

export default TransferToUserConfirm;
